import React, { Fragment, useEffect } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Spinner from '../layout/Spinner';
// import DashboardActions from './DashboardActions';
import Experience from './Experience';
import Education from './Education';
import Profile from './Profile';
import { getCurrentProfile, deleteAccount } from '../../actions/profile';

const Dashboard = ({
  getCurrentProfile,
  deleteAccount,
  auth: { user },
  profile: { profile, loading }
}) => {
  useEffect(() => {
    getCurrentProfile();
  }, [getCurrentProfile]);

  return loading && profile === null ? (
    <Spinner />
  ) : (
    <Fragment>
      {profile !== null ? (
        <Fragment>
          <div className="row justify-content-center">
            <div className="col-12 col-md-9 col-lg-5 col-xl-5">
              <Profile profile={profile} user={user} />
            </div>
            {/* <DashboardActions /> */}
            <div className="col-12 col-md-9 col-lg-7 col-xl-6 my-0">
              <Education education={profile.education} />
              <Experience experience={profile.experience} />
              <button
                className="btn btn-danger btn-sm shadow-sm float-right my-3"
                onClick={() => deleteAccount()}
              >
                <i className="far fa-trash-alt"></i> Delete My Account
              </button>
            </div>
          </div>
        </Fragment>
      ) : (
        <Fragment>
          <div className="row justify-content-md-center">
            <div className="col-11 col-sm-8 col-md-8 col-lg-5 col-xl-4">
              <div id="create-profile-card">
                <div className="card-body">
                  {/* <div className="d-flex mb-3">
                    <div className="edit-pic">
                      {' '}
                      <img
                        src={user.avatar}
                        className="rounded-circle shadow-sm d-block"
                        style={{ height: '85px', width: '85px' }}
                        alt=""
                      />
                    </div>
                    <div className="ml-2 align-self-center">
                      {' '}
                      <h6 className="rb mb-0 bold">{user.name}</h6>
                      <span className="text-muted username bold rb">
                        {user.email}
                      </span>
                    </div>
                  </div> */}
                  <p>You have not yet setup a profile, please add some info</p>
                  <Link
                    to="/create-profile"
                    className="btn profile-form-btn primary-btn"
                  >
                    Create Profile
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </Fragment>
      )}
    </Fragment>
  );
};

Dashboard.propTypes = {
  getCurrentProfile: PropTypes.func.isRequired,
  deleteAccount: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
  profile: PropTypes.object.isRequired
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  profile: state.profile
});

export default connect(mapStateToProps, { getCurrentProfile, deleteAccount })(
  Dashboard
);
